import { ExamQuestionsSource } from "features/exam-questions/analytics";
import { ROUTES } from "routing/routes";

// use this whenever linking to Exam Questions mode selection

export const makeLinkToCourseExamQuestionsHomepageSelectModeWithState = ({
  courseId,
  source,
  selectedQuestionIds
}: {
  courseId: string;
  source: ExamQuestionsSource;
  selectedQuestionIds?: string[];
}) => ({
  pathname: ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.SELECT_MODE.buildPath({
    courseId
  }),
  state: ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.SELECT_MODE.buildState({
    source,
    selectedQuestionIds
  })
});
